// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v0.1.10-1-g8f82e90",
    "hash": "g8f82e90",
    "distance": 1,
    "tag": "v0.1.10",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v0.1.10",
        "major": 0,
        "minor": 1,
        "patch": 10,
        "prerelease": [],
        "build": [],
        "version": "0.1.10"
    },
    "suffix": "1-g8f82e90",
    "semverString": "0.1.10+1.g8f82e90",
    "version": "0.1.10"
};
